import React from 'react';
import { ListItem, Tooltip } from '@ds';
import { ViewItemData } from './utils';
import styles from './ViewSelect.module.scss';

type OptionalTooltipProps = {
  content: string;
  children: React.ReactNode;
};
const OptionalTooltip = ({ content, children }: OptionalTooltipProps) => {
  if (content.length < 40) {
    return <>{children}</>;
  }

  return (
    <Tooltip content={content}>
      <>{children}</>
    </Tooltip>
  );
};

type ViewSelectOptionProps = {
  data: ViewItemData;
  selectedViewId?: string | null;
  actionList: React.ReactNode;
  onClick: () => void;
};
const ViewSelectOption: React.FC<ViewSelectOptionProps> = ({
  data,
  selectedViewId,
  actionList,
  onClick
}) => {
  const { name, source, id } = data;
  const isSelected = selectedViewId === id;

  const onItemClick = () => {
    if (isSelected) return;

    onClick();
  };

  return (
    <div className={styles.optionContainer}>
      <ListItem
        active={isSelected}
        onClick={onItemClick}
        data-test="view-select-option-item"
      >
        <OptionalTooltip content={name}>
          <ListItem.Text primary={name} secondary={source} />
        </OptionalTooltip>

        {actionList}
      </ListItem>
    </div>
  );
};

export default ViewSelectOption;
